import { render, staticRenderFns } from "./takingsOverviewChart.vue?vue&type=template&id=48b2be69&"
import script from "./takingsOverviewChart.vue?vue&type=script&lang=ts&"
export * from "./takingsOverviewChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports